/**
反算工具类
ver 1.0.0
修改记录：
  2021-01-21：
    sheetsBackCountUtil.
*/
import calculateUtils from '../calculateUtil'
let sheetsBackCountUtil = {}

/**
 * 参与计算对应字段 只做正向计算，即选择打印单位后计算，用户填写时不反向计算
 * @基本数量 {[amount]}
 * @基本单位 {[unit]}
 * @打印单位 {[unitDisplay]}
 * @每标签基本打印数量 {[amountBasic]} amountBasic = ratio.dividend/ratio.divisor
 * @建议打印张数 {[amountDisplay]} amountDisplay = 基本单位amount * ratio.divisor / ratio.dividend
 * @打印张数 {[sheet]} sheet = amountDisplay
 * @打印总张数 {[sheets]} sheets = sheet * copies 后台计算
 * @份数 {[copies]}  默认1 (暂时不展示)
 */

/**
 * [在表格中修改打印单位，修改 每标签基本打印数量，建议打印张数，打印张数]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 */
sheetsBackCountUtil.unitDisplay = function (data, formData, decimal = 0) {
  data.amountBasic = calculateUtils.numberDiv(
    data.unitDisplay.ratio.dividend,
    data.unitDisplay.ratio.divisor,
    6
  )
  data.amountDisplay = calculateUtils.numberDiv(
    calculateUtils.numberMul(data.amount, data.unitDisplay.ratio.divisor, decimal),
    data.unitDisplay.ratio.dividend,
    0
  )
  data.sheet = calculateUtils.numberDiv(
    calculateUtils.numberMul(data.amount, data.unitDisplay.ratio.divisor, decimal),
    data.unitDisplay.ratio.dividend,
    decimal
  )
}

export default sheetsBackCountUtil
